import { LookupDTO } from './lookup.model';

/**
 * Modello per memorizzare i dati del cliente
 */
export class CustomerDTO {
  public ID: number;
  public Denomination: string;
  public VatNumber: string;
  public Telephone: string;
  public Mobile: string;
  public Address: string;
  public IBAN: string;
  public Email: string;
  public WebSite: string;
  public FiscalCode: string;
  public City: string;
  public IsVendor: boolean;
  public IsCustomer: boolean;
  public District: string;
  public PostalCode: string;
  public LATX: number;
  public LNGX: number;
  public CodDestFE: string;
  public PecDestFE: string;
  public RifAmmFE: string;
  public Country: string;
  public Currency: string;
  public StreetNumber: string;
  public Street: string;
  public Split: boolean;
  public AddebitaBollo: boolean;
  public Name: string;
  public Surname: string;
  public IsPA: boolean;
  public Deleted: boolean;
  public F_NaturalPerson: boolean;
  public DocumentCausal: string;
  public Type: string;
  public FK_Company: number;
  public FullAddress: string;

  public CustomerType: LookupDTO;
  public PaymentType: LookupDTO;
  public PaymentCondition : LookupDTO;
  public Nation: LookupDTO;

  public FK_InsertUser: number;
  public InsertDate: Date;
  public FK_UpdateUser: number;
  public UpdateDate: Date;

  public IsDisabled: boolean;
  public DisabledLastChangeDate: Date;

  public Label: string;

  public IsCarrier : boolean;
  public CarrierTitle :string;
  public CarrierEORICode : string;
  public CarrierDrivingLicenseNumber : string;

  public IsUsed : boolean;
  public Title : string;
  public EoriCode : string;
  public FlagOpposizioneSTS: boolean;  
  public PaymentConditionNoQuestion: boolean;


  //Francia
  public FR_Siren :string
  public FR_Nic :string
  public FR_TVA :string
  public FR_Siret :string
  public FR_ComplementAddress :string
  public FR_CountrySubentity :string
}

export class CustomerListDTO {
  public ID: number;
  public Denomination: string;
  public Name: string;
  public Surname: string;
  public CustomerType: LookupDTO;
  public VatNumber: string;
  public FiscalCode: string;
  public City: string;
  public District: string;
  public PostalCode: string;
  public CodDestFE: string;
  public Nation: LookupDTO;
  public FK_Company: number;
  public Type: string;
  public IsCarrier : boolean;

  public FK_InsertUser: number;
  public InsertDate: Date;
  public FK_UpdateUser: number;
  public UpdateDate: Date;

  public IsDisabled: boolean;
  public DisabledLastChangeDate: Date;

  public IsUsed : boolean;
  public HasStableOrganisation : boolean;
  public HasFiscalAgent : boolean;

  public FR_Siren :string  
  public FR_Siret :string
  public FR_Nic :string
  public FR_TVA :string
  public FR_ComplementAddress :string
  public FR_CountrySubentity :string
}

export class CustomerFilterDTO {
  public Denomination: string;
  public CodDestFE: string;
  public City: string;
  public Type: string;
  public FK_Company: number;
}
